import React from 'react';
import RestrictedActionForm from './RestrictedActionForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRestrictedActionIndexState, useRestrictedActionIndexActions } from './RestrictedActionIndexContext';
import { createRestrictedAction } from './restApi';

import styles from './RestrictedActionModal.module.scss';

const RestrictedActionModal = () => {
  const state = useRestrictedActionIndexState();
  const { closeRestrictedActionModal, onResponse, onError } = useRestrictedActionIndexActions();

  return (
    <StandardModal
      isOpen={state?.restrictedActionModalIsOpen}
      onRequestClose={() => {
        closeRestrictedActionModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Create Restricted Action
        </h2>
        <RestrictedActionForm
          onSubmit={(args) => {
            createRestrictedAction({
              ...args,
              onResponse,
              onError,
            });
          }}
          onCancel={closeRestrictedActionModal}
        />
      </section>
    </StandardModal>
  );
};

export default RestrictedActionModal;
